import { Dexie } from 'dexie';
export interface Category {
  category_id: string;
  category_name: string;
}

export interface Series {
// backdrop_path: []
// cast:string 
category_id:string 
cover:string 
// director:string 
// episode_run_time:string 
// genre:string 
// last_modified:string 
name: string
// num:number
// plot:string; 
// rating: string;
// rating_5based: number;
// releaseDate:string; 
series_id:number;
// tmdb_id:number;
// youtube_trailer:string;
}
export class SeriesdbService extends Dexie{

 categories: Dexie.Table<Category, string>;
 series: Dexie.Table<Series, number>;
   constructor() {
    super('SeriesDB');
    this.version(1).stores({
      categories: 'category_id',
      series: '++id, series_id, category_id'
    });

    this.categories = this.table('categories');
    this.series = this.table('series');
  }
}

export const Seriesdb = new SeriesdbService()